import React, { useEffect, useReducer } from "react";
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { LoadingSpinner } from "../lib/components/LoadingSpinner";
import { withHeaderMessages } from "../higherOrderComponents/WithHeaderMessages";
import ConfirmationReceiptGenericPrint from "./ConfirmationReceiptGenericPrint";
import ConfirmationReceiptPrintKy from "./ConfirmationReceiptPrintKy";
import ConfirmationReceiptCemeteryPrint from "./ConfirmationReceiptCemeteryPrint";
import { useParams } from "react-router-dom";
import "./clearpoint-reports.css";

const ConfirmationReceiptPrint = (props) => {
  const initialState = {
    isLoading: true,
    contract: {
      provider: {
        address: {},
      },
      purchaser: {
        address: {},
      },
      recipients: [],
    },
    downPayment: 0,
    downPaymentLoading: true,
    purchases: [],
    purchasesLoading: true,
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "contractDetails":
        return {
          ...state,
          contract: action.payload,
          isLoading: false,
        };
      case "downPayment":
        return {
          ...state,
          downPayment: action.payload,
          downPaymentLoading: false,
        };
      case "isLoading":
        return {
          ...state,
          isLoading: action.payload,
        };
      case "hideLoader":
        return {
          ...state,
          isLoading: false,
        };
      default:
        throw new Error();
    }
  };

  const [confirmationReceiptState, dispatch] = useReducer(
    reducer,
    initialState,
  );
  const { number } = useParams();

  useEffect(() => {
    async function getContractDetails() {
      props.header.setHeader("confirmationReceiptPrint");
      await props.api
        .get(`/api/contract/${number}`)
        .then((response) => {
          if (response.status === 200) {
            return response.data;
          }
        })
        .then((data) => {
          dispatch({ type: "contractDetails", payload: data });
        })
        .catch(hideLoader)
        .then(hideLoader);
    }
    getContractDetails();
  }, []);

  useEffect(() => {
    async function getDownPaymentDetails() {
      await props.api
        .get(`/api/contract/${number}/down-payment`)
        .then((response) => {
          if (response.status === 200) {
            return response.data;
          }
        })
        .then((data) => {
          dispatch({ type: "downPayment", payload: data.totalPayments });
        })
        .catch(hideLoader)
        .then(hideLoader);
    }
    getDownPaymentDetails();
  }, []);

  const hideLoader = () => {
    dispatch({ type: "isLoading", payload: false });
  };

  if (
    confirmationReceiptState.isLoading ||
    confirmationReceiptState.downPaymentLoading
  ) {
    return <LoadingSpinner />;
  }

  const { contract, downPayment } = confirmationReceiptState;
  const fundingOptions = [
    ...new Set(contract?.purchases?.map((p) => p.trustTitle)),
  ];

  return (
    <div
      style={{ width: "8.25in", margin: "0" }}
      className="confirmation-receipt text-start"
    >
      {contract.provider.address.state !== "KY" &&
        contract.provider.providerType === 1 && (
          <ConfirmationReceiptGenericPrint
            contract={contract}
            downPayment={downPayment}
            fundingOptions={fundingOptions}
          />
        )}
      {contract.provider.address.state === "KY" &&
        contract.provider.providerType === 1 && (
          <ConfirmationReceiptPrintKy
            contract={contract}
            downPayment={downPayment}
            fundingOptions={fundingOptions}
          />
        )}
      {contract.provider.providerType === 2 && (
        <ConfirmationReceiptCemeteryPrint
          contract={contract}
          downPayment={downPayment}
          fundingOptions={fundingOptions}
        />
      )}
    </div>
  );
};

export default withHeaderMessages(WithApiAccess(ConfirmationReceiptPrint));
